import { useContext } from 'react';
import { UnifiedPermissionsContext } from './context';
import type { UnifiedPermissionsContextValue } from './types';

export const usePermissions = (): UnifiedPermissionsContextValue => {
  const context = useContext(UnifiedPermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within a UnifiedPermissionsProvider');
  }
  return context;
};
